import React from "react";
import { IconMessage, IconLogout, IconMenu2 } from "@tabler/icons-react";
import { useAuth } from "../../context/AuthContext";

interface HeaderProps {
  onToggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar }) => {
  const { user, logout, isAuthenticated } = useAuth();

  return (
    <header className="sticky top-0 z-30 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
      <button
        type="button"
        className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
        onClick={onToggleSidebar}
      >
        <IconMenu2 className="h-6 w-6" />
      </button>

      <div className="flex flex-1 justify-between items-center">
        <div className="flex items-center gap-2">
          <IconMessage className="h-6 w-6 text-brand-primary" />
          <h1 className="text-xl font-semibold text-gray-900">
            CitusHealth Assistant
          </h1>
        </div>

        {isAuthenticated && (
          <div className="flex items-center gap-4">
            <div className="hidden sm:flex items-center gap-2 text-sm text-gray-600">
              <span className="bg-brand-primary/10 px-2 py-1 rounded-md">
                {user?.username || user?.name || user?.email}
              </span>
            </div>
            <button
              onClick={() => logout()}
              className="flex items-center gap-2 text-gray-600 hover:text-brand-primary transition-colors"
              aria-label="Sign out"
            >
              <IconLogout className="h-5 w-5" />
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
